import React from "react"

const AnsweredFormOverviewContext = React.createContext(null)

export default AnsweredFormOverviewContext
